import { Component, computed, inject, signal} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsuarioService } from 'src/app/services/usuario.service';
import { Location } from '@angular/common';
import { Horario } from 'src/app/models/Horario';
import { Ubicacion } from 'src/app/models/Ubicacion';
import { API_URI } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-perfil-comercio',
    templateUrl: './perfil-comercio.component.html',
    styleUrls: ['./perfil-comercio.component.css'],
    standalone: false
})
export class PerfilComercioComponent {
  private _authService = inject(AuthService);
  private _usuarioService = inject(UsuarioService);
  private _loadingService = inject(LoadingService);
  private router = inject(Router);
  private _location = inject(Location);
  private aRoute = inject(ActivatedRoute);

  error   = signal<string>('');
  loading = computed(() => this._loadingService.isLoading());

  id: string;

  preview_img_avatar: string = '';
  nombre: string = '';
  b_envio_domicilio: boolean = false;
  b_pago_mercadopago: boolean = false;
  ubicaciones: Ubicacion[] = [];
  horario: Horario | null = null;

  constructor(){
      this.id = this.aRoute.snapshot.paramMap.get('id') ?? '';
  }

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    // si no vino id, salir
    if (!this.id) {
      this.error.set('Falta el identificador de usuario.');
      this.router.navigate(['/sign-in']);
      return;
    }

    // Si necesitás (re)cargar usuario/cliente desde backend, hacelo bajo el loader:
    await this._loadingService.run(async () => {
      try {
        // Asegura bootstrap de sesión (idempotente, ok en web/nativo)
        // 1) sesión
        await this._authService.ensureSession();

        // 2) cargo usuario + comercio en paralelo
        const [u, c, horario, ubicaciones] = await Promise.all([
          firstValueFrom(this._usuarioService.getUsuarioXId(this.id)),
          firstValueFrom(this._usuarioService.getComercioXId(this.id)),
          firstValueFrom(this._usuarioService.getHorario(this.id, true)),
          firstValueFrom(this._usuarioService.getUbicaciones(this.id, true)),
        ]);

        // Si no existe el usuario, no podés editar
        if (!u) {
          this.error.set('El usuario no existe o fue eliminado.');
          this.router.navigate(['/dashboard']);
          return;
        }

        // --- Usuario ---
        //this.email = u?.x_email ?? '';
        this.preview_img_avatar = u?.x_img_avatar
          ? `${API_URI}uploads/images/large-${u.x_img_avatar}`
          : '';

        // --- Comercio ---
        this.nombre = c?.x_nombre_fantasia  ?? c?.x_razon_social ?? '';
        this.b_pago_mercadopago = c?.b_mercadopago ?? false;
        this.b_envio_domicilio = c?.b_envios ?? false;

        // --- Horario ---
        this.horario = horario; // puede ser null (ej: todavía no cargó horarios)

        // --- Ubicaciones ---
        this.ubicaciones = ubicaciones ?? [];
      } catch (e: any) {
        console.error(e);
        this.error = e?.message || 'No se pudo cargar el perfil.';
        this.router.navigate(['/sign-in']);
      }
    });
  }

  back(){
    this._location.back();
  }
}
